import { IMaterialConfiguration, ISapConfigureMaterialRequest } from './types'

export const blankRequest: ISapConfigureMaterialRequest = {
  MaterialNumber: '',
  CustomerNumber: '',
  Values: [],
  UserValues: [],
}

export const blankConfiguration: IMaterialConfiguration = {
  InstanceId: '',
  ConfiguratorHandle: '',
  Values: [],
  AllowedCharacteristics: [],
  IncompleteCharacteristics: [],
  InconsistentCharacteristics: [],
  ConstraintConflicts: [],
  Invisible: [],
  Characteristics: {},
  OrderItems: [],
}
